import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAddBranch(props: IconProps) {
  return (
    <BaseIcon size={16} {...props}>
      <path
        d="M17 11C17.5523 11 18 11.4477 18 12V15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V17H13C12.4477 17 12 16.5523 12 16C12 15.4477 12.4477 15 13 15H16V12C16 11.4477 16.4477 11 17 11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V8C16 8.55228 15.5523 9 15 9H13V11H14C14 11 15 11 15 12C15 13 14 13 14 13H8V15H10C10.5523 15 11 15.4477 11 16V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15H6V12C6 11.4477 6.44772 11 7 11H11V9H9C8.44772 9 8 8.55228 8 8V4ZM10 5V7H14V5H10ZM5 17V19H9V17H5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
